import { CloseOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { RenderHtml3 } from './renderhtml';

export function Tips(props) {
  let { hidetips, savetips } = props
  console.log(savetips)
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
        <div className="shawdowlayer" onClick={() => {
          hidetips()
        }}>
          <div className="tipsbox" onClick={(e) => {
            e.stopPropagation()
          }}>
            <CloseOutlined className="CLOSEbtn" onClick={() => hidetips()} />
            <div className="modalcontent">
              <RenderHtml3 state={{ content: savetips }} />
            </div>
          </div>

        </div>
      </Col>
      <Col sm={24} xs={24} md={24} lg={0} xl={0}>
        <div className="shawdowlayer" onClick={(e) => {
          hidetips()
        }}>
          <div className="tipsboxph" onClick={(e) => {
            e.stopPropagation()
          }}>
            <CloseOutlined className="CLOSEbtnph" onClick={() => hidetips()} />
            <div className="modalcontentph">
              <RenderHtml3 state={{ content: parseStr(savetips) }} />
            </div>
          </div>
        </div>
      </Col>
    </Row >
  )
}
function parseStr(str = '') {
  return str.replace(/font-size:.*?(?=px)/g, (value) => {
    let newValue = Math.ceil(parseInt(value.replace(/font-size:/g, '')) / 1.7)
    return `font-size:${newValue}`
  })
}